import moment from "moment-timezone";

export const parsePlan = (app: string, str: string | null) => {
  let match;
  if (str) {
    switch (app) {
      case "eam":
        match = str.match(/^eam_(.*?)_plan$/);
        break;
      case "qrit":
        match = str.match(/^qrit_(.*?)_plan$/);
        break;
      case "smarttd":
        match = str.match(/^smarttd_(.*?)_plan$/);
        break;
      case "smartwn":
        match = str.match(/^smartwn_(.*?)_plan$/);
        break;
      case "stp":
        match = str.match(/^stp_(.*?)_plan$/);
        break;
      default:
        match = "free";
        break;
    }
    return match ? match[1] : "free";
  } else {
    return "free";
  }
};

export const convertUTCToLocal = (utcDateStr: string) => {
    return moment
      .utc(utcDateStr) // Parse as UTC
      .tz(moment.tz.guess())
      .format("MMMM D, YYYY, HH:mm:ss");
  };
